import Splide from '@splidejs/splide';
import {getPreviousSiblings} from '../utilities/helpers'

export default () => {
  const horizontalTimeline = document.querySelector('#timeline-splide'),
        horizontalTimelineItems = document.querySelectorAll('.timeline-slider-item');
        
  if(!horizontalTimeline) return;

  const perPage = horizontalTimeline.getAttribute('data-perpage'),
        perPageRounded = Math.floor(perPage),
        perPageDecimal = perPage - Math.floor(perPage),
        type = horizontalTimeline.getAttribute('data-type');

  const splide = new Splide(horizontalTimeline, {
    perPage: 1,
    perMove: 1,
    arrows: false,
    pagination: false,
    gap: '10px',
    mediaQuery: 'min',
    padding:{
      right: '125px'
    },
    breakpoints: {
      768: {
        perPage: 2,
      },
      1024: {
        perPage: perPageRounded,
      },
      1200: {
        padding: {
          right: type === 'default' ? '70px' : '0'
        }
      }
    }
  });

  if (perPageDecimal != 0 && window.matchMedia('min-width: 768px')) {
    splide.on('mounted', function () {
      const lastSlide  = splide.length - 1,
            slideLastItem = splide.Components.Elements.slides[lastSlide],
            slideLastItemWidth = slideLastItem.offsetWidth,
            splidePadding = slideLastItemWidth * perPageDecimal;
  
      splide.options = {
        padding: {
          right: type === 'default' ? '70px' : splidePadding + 'px'
        }
      }
      splide.refresh()
    });
  }

  splide.mount();

  if(!horizontalTimelineItems) return;

  horizontalTimelineItems.forEach((item, key) => {
    item.addEventListener('click', () => {
      item.classList.add('active');
      const previousSiblings = getPreviousSiblings(item);
      previousSiblings.forEach( prev => {
        prev.classList.add('active');
      });
      if ( window.matchMedia('max-width: 992px') ) {
        splide.go(key);
      } else {
        splide.go(key+1);
      }
    });
  });
}